import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { optionsDateWhioutTime } from '../../../../shared/const'
import { formatDate } from '../../../../shared/datetime'

import styles from './reportIntro.module.scss'

/*
 * Kopf eines Berichtsformulars.
 *
 * Bis 07.08.2026 stand hier immer dasselbe: die Frist und der Satz „Um die …
 * erfolgreich abzuschließen muss die folgende Endabrechnung gemacht werden."
 * Auch dann noch, wenn der Bericht längst abgegeben war — also gerade in der
 * Ansicht, in der ihn eine Lehrkraft oder die Verwaltung liest. Eine Frist, die
 * vorbei ist, und eine Aufforderung, die niemand mehr befolgen kann, lesen sich
 * wie veraltete Daten.
 *
 * Abgegeben heißt jetzt: Datum der Abgabe statt Frist, kein Arbeitsauftrag.
 */
export default function ReportIntro({ isSubmitted, deadline, submittedAt, instruction }) {
	const { t } = useTranslation()

	// Wiener Zeit, nicht die des Rechners: Eine Frist, die um Mitternacht
	// abläuft, stünde sonst je nach Standort einen Tag daneben.
	const asDate = value => formatDate(value, optionsDateWhioutTime) || null

	if (isSubmitted) {
		const submitted = asDate(submittedAt)

		return (
			<section className={styles.root}>
				<p className={styles.headline}>
					{submitted ? t('Submitted on {{date}}', { date: submitted }) : t('Report submitted')}
				</p>
			</section>
		)
	}

	const due = asDate(deadline)

	return (
		<section className={styles.root}>
			{due && <p className={styles.headline}>{`${t('Deadline by')} ${due}`}</p>}
			{instruction && <p className={styles.instruction}>{instruction}</p>}
		</section>
	)
}

ReportIntro.propTypes = {
	isSubmitted: PropTypes.bool,
	deadline: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]),
	submittedAt: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]),
	instruction: PropTypes.string
}
